export const PERSISTENT_FILTERS_STORAGE_KEY = "app_persistent_filters";

const isBrowser = typeof window !== "undefined" && typeof window.localStorage !== "undefined";

function isPlainObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function sanitizeModuleFilters(raw) {
  if (!isPlainObject(raw)) {
    return {};
  }

  const next = {};

  Object.entries(raw).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      return;
    }

    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      next[key] = value;
    }
  });

  return next;
}

function sanitizeFiltersState(raw) {
  if (!isPlainObject(raw)) {
    return {};
  }

  const next = {};

  Object.entries(raw).forEach(([moduleKey, moduleFilters]) => {
    const sanitized = sanitizeModuleFilters(moduleFilters);
    if (Object.keys(sanitized).length > 0) {
      next[moduleKey] = sanitized;
    }
  });

  return next;
}

export function loadFiltersFromStorage() {
  if (!isBrowser) {
    return {};
  }

  try {
    const raw = window.localStorage.getItem(PERSISTENT_FILTERS_STORAGE_KEY);
    if (!raw) {
      return {};
    }

    return sanitizeFiltersState(JSON.parse(raw));
  } catch {
    return {};
  }
}

export function saveFiltersToStorage(state) {
  if (!isBrowser) {
    return;
  }

  try {
    const sanitized = sanitizeFiltersState(state);
    if (Object.keys(sanitized).length === 0) {
      window.localStorage.removeItem(PERSISTENT_FILTERS_STORAGE_KEY);
      return;
    }

    window.localStorage.setItem(
      PERSISTENT_FILTERS_STORAGE_KEY,
      JSON.stringify(sanitized)
    );
  } catch {
    // Storage may be unavailable (private mode, quota exceeded, etc.).
  }
}

export function clearModuleFromStorage(moduleKey) {
  const current = loadFiltersFromStorage();
  if (!(moduleKey in current)) {
    return;
  }

  const next = { ...current };
  delete next[moduleKey];
  saveFiltersToStorage(next);
}

export function clearAllFiltersFromStorage() {
  if (!isBrowser) {
    return;
  }

  try {
    window.localStorage.removeItem(PERSISTENT_FILTERS_STORAGE_KEY);
  } catch {
    // Storage may be unavailable (private mode, quota exceeded, etc.).
  }
}

export function preservePersistentFiltersDuringClear() {
  return loadFiltersFromStorage();
}

export function restorePersistentFiltersAfterClear(saved) {
  saveFiltersToStorage(saved);
}
